import { AxiosResponse } from "axios"
import { axiosInstance, MessageResponse } from "./common"

interface ContentWithMetadata {
    value: string;
    ai_generated: string;
    user_updated: string;
}

export interface PersonInvolved {
    name: string
    action: string
    approver: string
    date: Date
    comments: string
    ai_generated: Boolean
    user_updated: Boolean
}

export interface PolicyImprovement {
    policy_change: string
    approver: string
    date: Date
    comments: string
    ai_generated: Boolean
    user_updated: Boolean
}

export interface GenerateRecommendationRequest {
  case_id: string
}

export interface GetRecommendationParams extends GenerateRecommendationRequest {}
// export interface CollateralVerificationRecord extends BaseDocumentVerificationRecord {}

export interface UpdateRecommendationsRequest {
  recommendations?: ContentWithMetadata
  persons_involved?: PersonInvolved[]
  policy_improvements?: PolicyImprovement[]
}


export interface RecommendationAPIResponse {
    case_id: string
    recommendations: ContentWithMetadata | null
    persons_involved: PersonInvolved[] | null
    policy_improvements: PolicyImprovement[] | null
    data_used?: Record<string, any> | null
}

const RecommendationsAPI = {
    create: async (request: GenerateRecommendationRequest) => {
        const response: AxiosResponse<RecommendationAPIResponse> = await axiosInstance.post('v1/recommendations/generate', request);
        return response.data;
    },

    get: async (params: GetRecommendationParams) => {
        const response: AxiosResponse<RecommendationAPIResponse> = await axiosInstance.get('v1/recommendations',{
            params: params
        });
        return response.data;
    },

    update: async (caseId: string, request: UpdateRecommendationsRequest) => {
        const response: AxiosResponse<MessageResponse> = await axiosInstance.patch(`/v1/cases/${caseId}/recommendations`, request);
        return response.data;
    }
}

export default RecommendationsAPI;